import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1920,436.363636 L1570.90909,436.363636 L1570.90909,87.2727273 L1396.36364,87.2727273 L1396.36364,436.363636 L1047.27273,436.363636 L1047.27273,610.909091 L1396.36364,610.909091 L1396.36364,960 L1570.90909,960 L1570.90909,610.909091 L1920,610.909091 L1920,436.363636 Z M698.181818,436.363636 L698.181818,610.909091 L174.545455,610.909091 L174.545455,1658.18182 L1396.36364,1658.18182 L1396.36364,1309.09091 L1570.90909,1310.88 L1570.90909,1658.18182 C1570.90909,1754.53091 1492.71273,1832.72727 1396.36364,1832.72727 L174.545455,1832.72727 C78.1090909,1832.72727 0,1754.53091 0,1658.18182 L0,610.909091 C0,514.472727 78.1090909,436.363636 174.545455,436.363636 L698.181818,436.363636 Z M610.900364,785.445818 L610.900364,1483.62764 L1134.53673,1134.53673 L610.900364,785.445818 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconAddMediaSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconAddMediaSolid, _Component);

  var _super = _createSuper(IconAddMediaSolid);

  function IconAddMediaSolid() {
    _classCallCheck(this, IconAddMediaSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconAddMediaSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconAddMedia",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconAddMediaSolid.displayName = "IconAddMediaSolid";
  return IconAddMediaSolid;
}(Component);

IconAddMediaSolid.glyphName = 'add-media';
IconAddMediaSolid.variant = 'Solid';
IconAddMediaSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconAddMediaSolid;
export { IconAddMediaSolid };